module.exports = __webpack_public_path__ + "static/media/img5.5792e5ba.jpg";